import { useCallback } from 'react'

import { useSelector } from 'react-redux'
import { faEdit, faPlus } from '@fortawesome/pro-solid-svg-icons'
import { Select } from 'antd'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import IconButton from '../../../antd/Buttons/IconButton'
import { Sector } from '../../../../utils/entities/sector'
import { TableActions } from '../../../antd/Tables/DataTable/utils/actions'

import '../../../../assets/editable-sector-selector.scss'

/**
 * An unmanaged place has nobody maintaining its sectors from the institution side : the student typing the
 * request is the only one able to keep that list current, hence the inline add / edit this selector offers
 * on top of the plain picker.
 */
const EditableSectorSelector = ({ className = '', disabled, institution, sectors = [], style = {}, value, onChange, onTriggerAction }) => {
  const t = useSelector(selectTranslate)

  const filterOption = useCallback((input, option) => (option.props.label ?? '').toLowerCase().includes(input.toLowerCase()), [])

  return (
    <Select
      className={className}
      disabled={disabled}
      filterOption={filterOption}
      style={style}
      value={value}
      onChange={onChange}
      showSearch
      dropdownRender={menu => (
        <div>
          {menu}
          <div className='editable-sector-selector-add' onMouseDown={e => e.preventDefault()}>
            <IconButton
              icon={faPlus}
              text={t('internship_request_form.sector.add')}
              onClick={() => onTriggerAction(new Sector({ institution }), TableActions.CREATE_SECTOR)}
            />
          </div>
        </div>
      )}
    >
      <Select.Option key={null} value={null} label='/'>
        {' '}
        /{' '}
      </Select.Option>
      {sectors.map(s => (
        <Select.Option key={s.id} value={s.id} label={s.name}>
          <div className='editable-sector-option'>
            <span>{s.name}</span>
            <IconButton
              className='editable-sector-option-edit'
              icon={faEdit}
              size='small'
              onClick={e => {
                e.stopPropagation()
                onTriggerAction(s, TableActions.EDIT_SECTOR)
              }}
            />
          </div>
        </Select.Option>
      ))}
    </Select>
  )
}

export default EditableSectorSelector
